import {
  isGroupSession,
  type AuthSession,
  type RootSession,
} from "@app/vue/providers/index";
import { instrumentation } from "@lemmonhq/analytics";
import { getAPIClient } from "../helpers";

export const sessionsAPI = {
  getCredentials: async () => {
    const client = getAPIClient();
    const resp = await client.api.v2.credentials.$get({
      query: {},
    });
    if (resp.ok) {
      return resp.json();
    } else {
      throw new Error("unable to fetch staff");
    }
  },
  getPublicStaffList: async (shopId: string) => {
    const client = getAPIClient();
    const resp = await client.api.v2.members.$get({
      query: {
        shopId,
      },
    });
    if (resp.ok) {
      return resp.json();
    } else {
      throw new Error("unable to fetch staff");
    }
  },
  loginWithPin: async (shopId: number, uid: number, pin: string) => {
    const client = getAPIClient();
    const resp = await client.api.v2.members["pin-login"].$post({
      json: { shopId, uid, pin },
    });
    if (resp.ok) {
      return resp.json();
    } else {
      throw new Error("unable to loginWithPin");
    }
  },

  getSession: async (): Promise<RootSession | undefined> => {
    const hc = getAPIClient();
    const response = await hc.api.session.$get();
    if (response.ok) {
      const userData = (await response.json()) as RootSession | null;
      if (userData) {
        // Group-mode session (cookie B): no POS identify. The Group shell
        // (Phase 4) renders it.
        if (isGroupSession(userData)) {
          return userData;
        }
        instrumentation.identify(userData as AuthSession);
        return userData as AuthSession;
      }
      return;
    }
  },
  createSession: async (email: string, password: string): Promise<any> => {
    const hc = getAPIClient();
    const response = await hc.api.session.$post({
      json: {
        email: email,
        password: password,
      },
    });
    if (!response.ok) {
      throw new Error("failed creating your session");
    }
    const data = await response.json();
    return data;
  },
  destroySession: async (): Promise<void> => {
    const hc = getAPIClient();
    const response = await hc.api.session.$delete();
    if (!response.ok) {
      throw new Error("failed logging you out");
    }
  },
};
